export default __webpack_public_path__ + "static/media/PhysicalDescriptions_03.38097452.png";